import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Api from "services/api";
import { formatServerDateTime } from "helpers/formatServerDateTime";

/**
 * Preview of one sent email exactly as it went out — the whole point of the log.
 * `portal` picks the API: "admin" (default) or "interpreter" (server-side scoped).
 */
const NotificationLogDetailModal = ({ logId, isOpen, toggle, portal = "admin" }) => {
  const [log, setLog] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!isOpen || !logId) return;
    let active = true;
    setLog(null);
    setLoading(true);
    const call = portal === "interpreter" ? Api.fetchMyNotificationLogDetail(logId) : Api.fetchNotificationLogDetail(logId);
    call
      .then((res) => {
        if (!active) return;
        if (res?.status >= 200 && res?.status < 300) {
          setLog(res?.data?.data || null);
        }
      })
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [isOpen, logId, portal]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" scrollable>
      <ModalHeader toggle={toggle}>Email Preview</ModalHeader>
      <ModalBody>
        {loading ? (
          <p style={{ textAlign: "center", color: "#809FB8" }}>Loading…</p>
        ) : !log ? (
          <p style={{ textAlign: "center", color: "#809FB8" }}>Could not load this email.</p>
        ) : (
          <>
            <div style={{ fontSize: 13, marginBottom: 12 }}>
              <div style={{ marginBottom: 4 }}><strong>To:</strong> <span className="text-break">{log.recipient}</span></div>
              <div style={{ marginBottom: 4 }}><strong>Subject:</strong> {log.subject || "(no subject)"}</div>
              <div><strong>Sent:</strong> {formatServerDateTime(log.created_at)}</div>
            </div>
            {/* The body is app-generated HTML (our own mail templates). If user-supplied
                content ever flows into emails, sanitise (DOMPurify) before rendering. */}
            <div
              style={{ border: "1px solid #E1E7EC", borderRadius: 8, padding: 12, background: "#fff", overflowX: "auto" }}
              dangerouslySetInnerHTML={{ __html: log.content_html || "<em>(empty body)</em>" }}
            />
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default NotificationLogDetailModal;
